function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.375 8H9.328c-.797 0-1.453.703-1.453 1.547V27.5c0 .844.656 1.5 1.453 1.5h18.047c.797 0 1.5-.656 1.5-1.5V9.547c0-.844-.703-1.547-1.5-1.547zM14.203 26H11.11v-9.984h3.094zm-1.547-11.39c-1.031 0-1.828-.797-1.828-1.782A1.83 1.83 0 0112.656 11c.985 0 1.781.844 1.781 1.828a1.78 1.78 0 01-1.78 1.781zM25.875 26h-3.14v-4.875c0-1.125 0-2.625-1.594-2.625-1.641 0-1.875 1.266-1.875 2.578V26h-3.094v-9.984h2.953v1.359h.047c.422-.797 1.453-1.64 2.953-1.64 3.14 0 3.75 2.109 3.75 4.78z",
  fill: "#fff"
});

var SvgLinkedIn = function SvgLinkedIn(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    width: 36
  }, props), _ref);
};

export default SvgLinkedIn;